import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import MobileNav from './MobileNav';

export default function Shell() {
  const [menuOpen, setMenuOpen] = useState(false);
  const loc = useLocation();

  // Close the mobile menu on route change — a link was just clicked.
  useEffect(() => { setMenuOpen(false); }, [loc.pathname]);

  return (
    <div className="min-h-screen flex bg-bg text-fg">
      <Sidebar />
      <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar onMenuClick={() => setMenuOpen(true)} />
        <main className="flex-1 px-5 sm:px-6 py-5 max-w-[1320px] w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
